<template>
  <div class="main">
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/banner.jpg"
    ></landingBanner>
    <div class="content">
    
      <footerForm color="#fff" bag="#d20001" words="获取学费"></footerForm>
      <div style="width:100%;height:20px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part1.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part2.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#d20001" style="width:100%" to="chat">在线了解详情</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part3.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div style="width:100%;height:30px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part4.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#d20001" style="width:100%" to="chat">在线了解详情</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part5.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div style="width:100%;height:30px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part6.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div class="button">
        <van-button color="#d20001" style="width:100%" to="chat">在线了解详情</van-button>
      </div>
      <div style="width:100%;height:40px;"></div>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/part7.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <router-link to="chat">
      <div class="list">
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/list1.jpg"
          />
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/list-2.jpg"
          />
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/list3.jpg"
          />
        </div>
        <div class="list-one">
          <van-image
            src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/girl/list4.jpg"
          />
        </div>
      </div>
    </router-link>

   
    <footerForm color="#fff" bag="#d20001" words="点击获取学费报价"></footerForm>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>

<script>
export default {
  components: {
    back: () => import('../../../components/head/back'),
    landingBanner: () => import('../../../components/common/landing-banner'),
    foot: () => import('@/components/foot/foot'),
    find2: () => import('@/components/common/find2'),
    indexTitle: () => import('@/components/common/indexTitle'),
    footerForm: () => import('@/components/form/footerForm'),
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.content {
   width: 100%;
  padding: 10px;
  background: #fff;
}
.button {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
  background: #fff;
}
.list-one {
  margin-bottom: 6px;
  width: 48.5%;
}
</style>
